import React, { useState } from 'react';

import Kpi from '@components/Kpi';

import { useKPI } from '@hooks/kpis/useKPI';

import { kpi } from '@store/selectors';
import { useAppDispatch, useAppSelector } from '@store/store';

import {
	clearCompareCharts,
	clearCorrelateCharts,
	setCompareCharts,
	setCorrelateCharts,
} from '@slices/kpi';

import { IChart } from '@interfaces/kpi/kpiCommon';
import { IGroupSelectOptions } from '@components/common/GroupSelectKpi/GroupSelect.types';

import { EAdminPanelPageTitles, EVendorsValues } from '@enums/common';

const DashboardKpis = () => {
	const dispatch = useAppDispatch();

	const [isWithInterval, setIsWithInterval] = useState<boolean>(false);
	const [vendor, setVendor] = useState<string>('');

	const isOranVendor = vendor === EVendorsValues.oran;
	const isLimenetVendor = vendor === EVendorsValues.limenet;

	const {
		compareCharts,
		compareSettings,
		correlateCharts,
		correlateSettings,
	} = useAppSelector(kpi);

	const {
		charts,
		compareDrillDownCharts,
		correlation,
		deletePreset,
		drillDownCharts,
		exportCharts,
		exportChartsFromParams,
		exportCorrelateCharts,
		exportCompareCharts,
		getCharts,
		getCorrelation,
		getDrillDownCharts,
		getDrillDownCompareCharts,
		handleCheckCreatePreset,
		handleCheckUpdatePreset,
		handleUpdatePreset,
		isLoadingCharts,
		isLoadingCorrelation,
		isLoadingDrillDownCharts,
		isLoadingDrillDownCompareCharts,
		isLoadingOptions,
		isLoadingPresetForm,
		options4GFddLimenet,
		options4GFddNokia,
		options4GTddLimenet,
		options4GTddNokia,
		options5GLimenet,
		options5GNokia,
		options5GOran,
		optionsLimenetKpi,
		optionsNokiaKpi,
		optionsVendorsKpi,
		presets,
		setDefaultKpiVendor,
		errorTextKpi,
		runProgress,
		progress,
	} = useKPI({
		isOranVendor,
	});

	const addChartToCompare = (chart: IChart) => dispatch(setCompareCharts({ chart }));

	const clearAllCompareCharts = () => dispatch(clearCompareCharts());

	const addChartToCorrelate = (chart: IChart) => dispatch(setCorrelateCharts({ chart }));

	const clearAllCorrelateCharts = () => dispatch(clearCorrelateCharts());

	return (
		<Kpi
			addChartToCompare={addChartToCompare}
			addChartToCorrelate={addChartToCorrelate}
			charts={charts}
			clearCompareCharts={clearAllCompareCharts}
			clearCorrelateCharts={clearAllCorrelateCharts}
			compareCharts={compareCharts}
			compareDrillDownCharts={compareDrillDownCharts}
			compareSettings={compareSettings}
			correlateCharts={correlateCharts}
			correlateSettings={correlateSettings}
			correlation={correlation}
			createPreset={handleCheckCreatePreset}
			deletePreset={deletePreset}
			drillDownCharts={drillDownCharts}
			errorTextKpi={errorTextKpi}
			exportCharts={exportCharts}
			exportChartsFromParams={exportChartsFromParams}
			exportCompareCharts={exportCompareCharts}
			exportCorrelateCharts={exportCorrelateCharts}
			getCharts={getCharts}
			getCorrelation={getCorrelation}
			getDrillDownCharts={getDrillDownCharts}
			getDrillDownCompareCharts={getDrillDownCompareCharts}
			isLimenetVendor={isLimenetVendor}
			isLoadingCharts={isLoadingCharts}
			isLoadingCorrelation={isLoadingCorrelation}
			isLoadingDrillDownCharts={isLoadingDrillDownCharts}
			isLoadingDrillDownCompareCharts={isLoadingDrillDownCompareCharts}
			isLoadingOptions={isLoadingOptions}
			isLoadingPresetForm={isLoadingPresetForm}
			isOranVendor={isOranVendor}
			isWithInterval={isWithInterval}
			options4GFddLimenet={options4GFddLimenet}
			options4GFddNokia={options4GFddNokia}
			options4GTddLimenet={options4GTddLimenet}
			options4GTddNokia={options4GTddNokia}
			options5GLimenet={options5GLimenet}
			options5GNokia={options5GNokia}
			options5GOran={options5GOran}
			optionsLimenetKpi={optionsLimenetKpi as IGroupSelectOptions[]}
			optionsNokiaKpi={optionsNokiaKpi as IGroupSelectOptions[]}
			optionsVendorsKpi={optionsVendorsKpi}
			presets={presets}
			progress={progress}
			runProgress={runProgress}
			setDefaultKpiVendor={setDefaultKpiVendor}
			setIsWithInterval={setIsWithInterval}
			setVendor={setVendor}
			title={EAdminPanelPageTitles.KPIDashboard}
			updatePreset={handleUpdatePreset}
			updatePresetName={handleCheckUpdatePreset}
			vendor={vendor}
		/>
	);
};

export default DashboardKpis;
